import React from "react";
import '../Components/CSS/Global.css'

const TermsAndConditions = () => {
  return (
    <div className="policy-hbt">
      <h1>Terms & Conditions</h1>
      <p>Last Updated: March 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>100billion Tech</strong>. By using our website and services, 
          you agree to comply with and be bound by these Terms and Conditions. 
          If you do not agree, please do not use our services.
        </p>
      </section>

      <section>
        <h2>2. Services</h2>
        <p>
          We offer digital marketing, website development, application development, 
          Google Ads, Meta Ads, and e-commerce solutions. The scope of each service 
          will be defined in a separate agreement.
        </p>
      </section>

      <section>
        <h2>3. User Responsibilities</h2>
        <p>By using our services, you agree to:</p>
        <ul>
          <li>Provide accurate and complete information when required.</li>
          <li>Not misuse our services for illegal or unethical activities.</li>
          <li>Ensure that all content provided does not violate any third-party rights.</li>
        </ul>
      </section>

      <section>
        <h2>4. Payments & Billing</h2>
        <ul>
          <li>Payments must be made as per the agreed terms before project commencement.</li>
          <li>Invoices must be cleared within the specified due date.</li>
          <li>Failure to make timely payments may result in service suspension.</li>
        </ul>
      </section>

      <section>
        <h2>5. Refund Policy</h2>
        <p>
          Our <a href="/refund-policy">Refund Policy</a> outlines the conditions under which refunds may be granted.
        </p>
      </section>

      <section>
        <h2>6. Intellectual Property</h2>
        <ul>
          <li>All content, logos, and designs created by 100billion Tech remain our intellectual property unless transferred.</li>
          <li>You may not use our branding or content without prior permission.</li>
        </ul>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <p>
          100billion Tech will not be liable for any indirect, incidental, or 
          consequential damages arising from the use of our services.
        </p>
      </section>

      <section>
        <h2>8. Termination of Services</h2>
        <p>
          We reserve the right to terminate or suspend services if you violate 
          these terms or engage in activities harmful to our company.
        </p>
      </section>

      <section>
        <h2>9. Changes to Terms</h2>
        <p>
          We may update these Terms and Conditions at any time. Your continued 
          use of our services after updates constitutes acceptance of the new terms.
        </p>
      </section>

      <section>
        <h2>10. Contact Us</h2>
        <p>
          For any questions, feel free to reach out:  
          <br />
          <strong>Email:</strong> support@100billiontech.com  
          <br />
          <strong>Phone:</strong> +91 8433-803-555  
          <br />
          <strong>Website:</strong> <a href="https://100billiontech.com" target="_blank" rel="noopener noreferrer">100billiontech.com</a>
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
